export const LoteIcon = ()=>{
  return <svg width="1em" height="1em" viewBox="-3 -3 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M18 18H0L3 10H10V12H10.67V6.99306L6 7V0H15.9998V7H11.33V12H12V10.002L15 10L18 18ZM8 4V5H14V4H8ZM8 3.0085V2.0085H14V3.0085H8Z" fill="currentColor"/>
  </svg>  
}